import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useState } from "react";
import cn from "clsx";
import { Bookmark as BookmarkFilled } from "@crehana/icons/fill";
import { Bookmark } from "@crehana/icons/outline";
import { Tooltip } from "@crehana/ui";
import { useSavedCoursesContext } from "../../../../ReactContexts/SavedCoursesContext";
import useBookmarkButtonTranslation from "./hooks/useBookmarkButtonTranslation";
import { jsx as _jsx } from "react/jsx-runtime";
var BookmarkButton = function BookmarkButton(_ref) {
  var isDark = _ref.isDark,
    course = _ref.course,
    dataTestid = _ref.dataTestid,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize,
    onBookmarkChange = _ref.onBookmarkChange,
    isBookmarkSelected = _ref.isSavedCourse,
    _ref$hideTooltip = _ref.hideTooltip,
    hideTooltip = _ref$hideTooltip === void 0 ? false : _ref$hideTooltip,
    _ref$colorType = _ref.colorType,
    colorType = _ref$colorType === void 0 ? 'primary-main' : _ref$colorType,
    source = _ref.source,
    sourceDetail = _ref.sourceDetail;
  var _useSavedCoursesConte = useSavedCoursesContext(),
    isEnabledSaveCourses = _useSavedCoursesConte.isEnabledSaveCourses,
    toggleBookmarkSelection = _useSavedCoursesConte.toggleBookmarkSelection;
  var _useBookmarkButtonTra = useBookmarkButtonTranslation(),
    t = _useBookmarkButtonTra.t;
  var _useState = useState(isBookmarkSelected),
    _useState2 = _slicedToArray(_useState, 2),
    isSavedCourse = _useState2[0],
    setIsSavedCourse = _useState2[1];
  var tooltipText = hideTooltip ? null : t(isSavedCourse ? 'BMK_BOOKMARK_SAVED_COURSE_TITLE' : 'BMK_BOOKMARK_SAVE_COURSE_TITLE');

  // Calc the icon colors based on the colorType prop
  var _useMemo = useMemo(function () {
      var colorTypeName = colorType;
      if (isDark) {
        // When isDark is true, we want to use the dark color for the selected color.
        if (colorTypeName === 'primary-main') {
          colorTypeName = 'secondary-light';
        }
      }
      switch (colorTypeName) {
        case 'primary-main':
          return ['text-primary-main', 'text-base-lighter'];
        case 'secondary-light':
          return ['text-secondary-light', 'text-base-lighter'];
        case 'white':
          return ['text-white', 'text-white'];
        default:
          console.warn('Unknown colorType:', colorTypeName);
          return ['text-white', 'text-white'];
      }
    }, [colorType, isDark]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    colorSelected = _useMemo2[0],
    colorDeselected = _useMemo2[1];
  var handleBookmarkClick = function handleBookmarkClick(event) {
    event.preventDefault();
    event.stopPropagation();
    var promiseSwap = toggleBookmarkSelection(isSavedCourse, String(course.originalId), {
      amplitudeData: {
        source: source,
        sourceDetail: sourceDetail
      }
    });
    var newState = !isSavedCourse;
    setIsSavedCourse(newState);
    promiseSwap["catch"](function () {
      // If cancels the action or failure, we want to revert the state back to the original.
      setIsSavedCourse(!newState);
    });
    return onBookmarkChange === null || onBookmarkChange === void 0 ? void 0 : onBookmarkChange(newState, course);
  };
  if (!isEnabledSaveCourses) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    label: tooltipText,
    isDark: isDark,
    children: /*#__PURE__*/_jsx("button", {
      onClick: handleBookmarkClick,
      type: "button",
      className: "ml-8",
      "data-testid": dataTestid,
      "data-bookmark-course-id": course.originalId,
      "aria-pressed": isSavedCourse,
      "aria-label": tooltipText || '',
      children: isSavedCourse ? /*#__PURE__*/_jsx(BookmarkFilled, {
        size: iconSize,
        ignoreColor: true,
        className: cn('fill-current', colorSelected)
      }) : /*#__PURE__*/_jsx(Bookmark, {
        size: iconSize,
        ignoreColor: true,
        className: cn('fill-current', colorDeselected)
      })
    })
  });
};
export default BookmarkButton;